



































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';
//@ts-ignore
import formPoaAvanceFisico from '@/components/formPoaAvanceFisico'

//@ts-ignore
import poa_actividades_lineas_accion from '@/mixins/axios/poa_actividades_lineas_accion'
//@ts-ignore
import poa_clasif_programaticas from '@/mixins/axios/poa_clasif_programaticas'
//@ts-ignore
import poa_finalidades from '@/mixins/axios/poa_finalidades'
//@ts-ignore
import poa_funciones from '@/mixins/axios/poa_funciones'
//@ts-ignore
import poa_subfunciones from '@/mixins/axios/poa_subfunciones'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'
//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    formPoaAvanceFisico,
    TablePPoa
  },
  data() {
    return {
    
  
        columnasd:[
           
            
           
             {
                tag:'lineaAccion',
                data:'lineaAccion',
                active:false
            },
            {
                tag:'Descripcion',
                data:'Descripcion',
                active:true
            },
            {
                tag:'UnidadActividad',
                data:'UnidadActividad',
                active:true
            },
            {
                tag:'fecha_inicial',
                data:'fecha_inicial',
                active:true
            },
            {
                tag:'fecha_final',
                data:'fecha_final',
                active:true
            },
             {
                tag:'indicador_administradores_id',
                data:'indicador_actividad',
                active:true
            }, {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
        ],




        id:null as any,


        
      Descripcion:null as any,
  
       UnidadActividad:null as any,
   fecha_inicial:null as any,
       fecha_final:null as any,
     indicador_administradores_id:0,
         statusmodal:0,
         poa_actividades_lineas_acciones_id:0 as any, descripcion1:0 as any, 
              poa_actividadlineaacciondata:[] as any,
              
      
    }
  },
     mixins: [poa_actividades_lineas_accion,indicador_administradores],
     validations: {
    
           Descripcion: {
      required,
    },
   
      UnidadActividad: {
      required,
    },
      fecha_inicial: {
      required,
    },
      fecha_final: {
      required,
    },
      indicador_administradores_id: {
      required,
    },
  },
  methods:{
      onChangeAdmi(event){
//console.log(event.target.value)
this.getDataAdministra(event.target.value);

},
      
       async getDataAdministra(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data3={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_ADMINISTRADORES(data3).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_administradores=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_ACTIVIDADES_LINEAS_ACCION(row).then(response => {

                    if (response != null) {

 this.poa_actividadlineaacciondata=this.poa_actividadlineaacciondata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.Descripcion=null;

    

                 this.UnidadActividad=null;

                 this.fecha_inicial=null;

                 this.fecha_final=null;

       
   this.indicador_administradores_id=0;
              

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_actividad_linea').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.Descripcion=row.Descripcion;
 this.UnidadActividad=row.UnidadActividad;
  this.fecha_inicial=row.fecha_inicial;
   this.fecha_final=row.fecha_final;
        this.indicador_administradores_id= row.indicador_administradores_id;      
          
 $('#ac_modal_actividad_linea').modal('show')
    

},
setlineaAccion(row){     
    console.log('entreeee/--------')  
    this.statusmodal=this.statusmodal+1;
        
 $('#modalCausa').modal('show')
     this.poa_actividades_lineas_acciones_id= row.id;    
this.descripcion1= row.Descripcion;
},
     async crear(dat){
let data= await this.CREAR_POA_ACTIVIDADES_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_actividadlineaacciondata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Poa Actividad Lineas Acción, refresque la pagina");

                    }    $("#ac_modal_actividad_linea").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_ACTIVIDADES_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador de areas modificado exitosamente, refresque la pagina");
  this.poa_actividadlineaacciondata=this.poa_actividadlineaacciondata.filter(item => item.id !== dat.id);
 this.poa_actividadlineaacciondata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Poa Actividad Lineas Acción, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           Descripcion:this.Descripcion,
            
               UnidadActividad:this.UnidadActividad,
                 fecha_inicial:this.fecha_inicial,
                   fecha_final:this.fecha_final,                         
           poa_lineas_acciones_id:this.$store.state.linea_accion_sel.id,
indicador_administradores_id:this.indicador_administradores_id,
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding');


let dat={
 poa_lineas_acciones_id:this.$store.state.linea_accion_sel.id,

};

let data= await this.GET_POA_ACTIVIDADES_LINEAS_ACCION(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_actividadlineaacciondata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
this.getDataAdministra();
  }
})
export default class Home extends Vue {}

